import constants from '../constants';
import axios from 'axios';

export const uploadAttachment = (data, onProgress, parentNodeRef) => {
  const token = encodeURIComponent(window.Alfresco.util.CSRFPolicy.getToken());
  return {
    type: constants.PROMISE_UPLOAD_ATTACHMENT,
    payload: axios({
      method: 'post',
      url: `${
        window.appContext
      }/proxy/alfresco/emvc/docLib/fileFromLocal?rootNrfString=${(parentNodeRef)}&${window.Alfresco.util.CSRFPolicy.getParameter()}=${token}`,
      data: data,
      headers: {
        [window.Alfresco.util.CSRFPolicy.getHeader()]: window.Alfresco.util.CSRFPolicy.getToken(),
      },
      onUploadProgress: event => onProgress(event),
    })
      .then(response => {
        if (response.status !== 200) {
          throw response.data;
        }
        return {
          nodeRef: response.data,
        };
      })
      .catch(reason => {
        throw reason?.response?.data?.message || 'Error';
      }),
  };
};

export const sortAttachmentsTable = key => ({
  type: constants.SORT_ATTACHMENTS_TABLE,
  payload: key,
});

export const updateState = (path, value) => ({
  type: constants.UPDATE_STATE,
  payload: { path, value },
});
